/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "јуче",
        "-2": "прекјуче",
        "0": "данас",
        "1": "сутра",
        "2": "прекосутра",
        "future": {
          "few": "за {0} дана",
          "one": "за {0} дан",
          "other": "за {0} дана"
        },
        "past": {
          "few": "пре {0} дана",
          "one": "пре {0} дана",
          "other": "пре {0} дана"
        }
      },
      "day-narrow": {
        "-1": "јуче",
        "-2": "прекјуче",
        "0": "данас",
        "1": "сутра",
        "2": "прекосутра",
        "future": {
          "few": "за {0} д.",
          "one": "за {0} д.",
          "other": "за {0} д."
        },
        "past": {
          "few": "пре {0} д.",
          "one": "пре {0} д.",
          "other": "пре {0} д."
        }
      },
      "day-short": {
        "-1": "јуче",
        "-2": "прекјуче",
        "0": "данас",
        "1": "сутра",
        "2": "прекосутра",
        "future": {
          "few": "за {0} д.",
          "one": "за {0} д.",
          "other": "за {0} д."
        },
        "past": {
          "few": "пре {0} д.",
          "one": "пре {0} д.",
          "other": "пре {0} д."
        }
      },
      "hour": {
        "0": "овог сата",
        "future": {
          "few": "за {0} сата",
          "one": "за {0} сат",
          "other": "за {0} сати"
        },
        "past": {
          "few": "пре {0} сата",
          "one": "пре {0} сата",
          "other": "пре {0} сати"
        }
      },
      "hour-narrow": {
        "0": "овог сата",
        "future": {
          "few": "за {0} ч.",
          "one": "за {0} ч.",
          "other": "за {0} ч."
        },
        "past": {
          "few": "пре {0} ч.",
          "one": "пре {0} ч.",
          "other": "пре {0} ч."
        }
      },
      "hour-short": {
        "0": "овог сата",
        "future": {
          "few": "за {0} ч.",
          "one": "за {0} ч.",
          "other": "за {0} ч."
        },
        "past": {
          "few": "пре {0} ч.",
          "one": "пре {0} ч.",
          "other": "пре {0} ч."
        }
      },
      "minute": {
        "0": "овог минута",
        "future": {
          "few": "за {0} минута",
          "one": "за {0} минут",
          "other": "за {0} минута"
        },
        "past": {
          "few": "пре {0} минута",
          "one": "пре {0} минута",
          "other": "пре {0} минута"
        }
      },
      "minute-narrow": {
        "0": "овог минута",
        "future": {
          "few": "за {0} мин.",
          "one": "за {0} мин.",
          "other": "за {0} мин."
        },
        "past": {
          "few": "пре {0} мин.",
          "one": "пре {0} мин.",
          "other": "пре {0} мин."
        }
      },
      "minute-short": {
        "0": "овог минута",
        "future": {
          "few": "за {0} мин.",
          "one": "за {0} мин.",
          "other": "за {0} мин."
        },
        "past": {
          "few": "пре {0} мин.",
          "one": "пре {0} мин.",
          "other": "пре {0} мин."
        }
      },
      "month": {
        "-1": "прошлог месеца",
        "0": "овог месеца",
        "1": "следећег месеца",
        "future": {
          "few": "за {0} месеца",
          "one": "за {0} месец",
          "other": "за {0} месеци"
        },
        "past": {
          "few": "пре {0} месеца",
          "one": "пре {0} месеца",
          "other": "пре {0} месеци"
        }
      },
      "month-narrow": {
        "-1": "прошлог мес.",
        "0": "овог мес.",
        "1": "следећег мес.",
        "future": {
          "few": "за {0} м.",
          "one": "за {0} м.",
          "other": "за {0} м."
        },
        "past": {
          "few": "пре {0} м.",
          "one": "пре {0} м.",
          "other": "пре {0} м."
        }
      },
      "month-short": {
        "-1": "прошлог мес.",
        "0": "овог мес.",
        "1": "следећег мес.",
        "future": {
          "few": "за {0} мес.",
          "one": "за {0} мес.",
          "other": "за {0} мес."
        },
        "past": {
          "few": "пре {0} мес.",
          "one": "пре {0} мес.",
          "other": "пре {0} мес."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "прошлог квартала",
        "0": "овог квартала",
        "1": "следећег квартала",
        "future": {
          "few": "за {0} квартала",
          "one": "за {0} квартал",
          "other": "за {0} квартала"
        },
        "past": {
          "few": "пре {0} квартала",
          "one": "пре {0} квартала",
          "other": "пре {0} квартала"
        }
      },
      "quarter-narrow": {
        "-1": "прошлог квартала",
        "0": "овог квартала",
        "1": "следећег квартала",
        "future": {
          "few": "за {0} кв.",
          "one": "за {0} кв.",
          "other": "за {0} кв."
        },
        "past": {
          "few": "пре {0} кв.",
          "one": "пре {0} кв.",
          "other": "пре {0} кв."
        }
      },
      "quarter-short": {
        "-1": "прошлог квартала",
        "0": "овог квартала",
        "1": "следећег квартала",
        "future": {
          "few": "за {0} кв.",
          "one": "за {0} кв.",
          "other": "за {0} кв."
        },
        "past": {
          "few": "пре {0} кв.",
          "one": "пре {0} кв.",
          "other": "пре {0} кв."
        }
      },
      "second": {
        "0": "сада",
        "future": {
          "few": "за {0} секунде",
          "one": "за {0} секунду",
          "other": "за {0} секунди"
        },
        "past": {
          "few": "пре {0} секунде",
          "one": "пре {0} секунде",
          "other": "пре {0} секунди"
        }
      },
      "second-narrow": {
        "0": "сада",
        "future": {
          "few": "за {0} с.",
          "one": "за {0} с.",
          "other": "за {0} с."
        },
        "past": {
          "few": "пре {0} с.",
          "one": "пре {0} с.",
          "other": "пре {0} с."
        }
      },
      "second-short": {
        "0": "сада",
        "future": {
          "few": "за {0} сек.",
          "one": "за {0} сек.",
          "other": "за {0} сек."
        },
        "past": {
          "few": "пре {0} сек.",
          "one": "пре {0} сек.",
          "other": "пре {0} сек."
        }
      },
      "week": {
        "-1": "прошле недеље",
        "0": "ове недеље",
        "1": "следеће недеље",
        "future": {
          "few": "за {0} недеље",
          "one": "за {0} недељу",
          "other": "за {0} недеља"
        },
        "past": {
          "few": "пре {0} недеље",
          "one": "пре {0} недеље",
          "other": "пре {0} недеља"
        }
      },
      "week-narrow": {
        "-1": "прошле н.",
        "0": "ове н.",
        "1": "следеће н.",
        "future": {
          "few": "за {0} н.",
          "one": "за {0} н.",
          "other": "за {0} н."
        },
        "past": {
          "few": "пре {0} н.",
          "one": "пре {0} н.",
          "other": "пре {0} н."
        }
      },
      "week-short": {
        "-1": "прошле нед.",
        "0": "ове нед.",
        "1": "следеће нед.",
        "future": {
          "few": "за {0} нед.",
          "one": "за {0} нед.",
          "other": "за {0} нед."
        },
        "past": {
          "few": "пре {0} нед.",
          "one": "пре {0} нед.",
          "other": "пре {0} нед."
        }
      },
      "year": {
        "-1": "прошле године",
        "0": "ове године",
        "1": "следеће године",
        "future": {
          "few": "за {0} године",
          "one": "за {0} годину",
          "other": "за {0} година"
        },
        "past": {
          "few": "пре {0} године",
          "one": "пре {0} године",
          "other": "пре {0} година"
        }
      },
      "year-narrow": {
        "-1": "прошле г.",
        "0": "ове г.",
        "1": "следеће г.",
        "future": {
          "few": "за {0} г.",
          "one": "за {0} г.",
          "other": "за {0} г."
        },
        "past": {
          "few": "пре {0} г.",
          "one": "пре {0} г.",
          "other": "пре {0} г."
        }
      },
      "year-short": {
        "-1": "прошле год.",
        "0": "ове год.",
        "1": "следеће год.",
        "future": {
          "few": "за {0} год.",
          "one": "за {0} год.",
          "other": "за {0} год."
        },
        "past": {
          "few": "пре {0} год.",
          "one": "пре {0} год.",
          "other": "пре {0} год."
        }
      }
    },
    "locale": "sr"
  });
}